import type { ApolloError } from "@qw/graphql";
import { Card, CardDescription, CardHeader, CardTitle } from "../card";
import { AuthError } from "./auth-error";

interface Props {
  header: React.ReactNode;
  subHeader?: React.ReactNode;
  error?: Error | ApolloError | null;
  children?: React.ReactNode;
}

export const AuthCard = ({ header, subHeader, children, error }: Props) => (
  <>
    {error && <AuthError error={error} />}
    <Card className="max-w-xs shadow-xl w-full">
      <CardHeader className="gap-3">
        <CardTitle className="text-2xl">{header}</CardTitle>
        {subHeader && <CardDescription>{subHeader}</CardDescription>}
      </CardHeader>
      {children}
    </Card>
  </>
);
